import CheckRounded from '@mui/icons-material/CheckRounded';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ComplianceChecklistItemStatus } from '../../../../../generated/core-api/graphql-react-query';
import useSessionContext from '../../../../LiveContext/SessionContextProvider/useSessionContext';
import ComplianceList from '../../../Compliance/ComplianceList';
import PanelLayout from '../PanelLayout';
import { CountBadge, EmptyState } from './styles';

export default function CompliancePanel() {
  const { compliance } = useSessionContext();
  const { t } = useTranslation();
  const pendingCount = compliance.filter((topic) => topic.result === ComplianceChecklistItemStatus.NotValidated).length;

  return (
    <PanelLayout
      icon={<CheckRounded />}
      title={t('right-panel.session-compliance.title')}
      badge={pendingCount > 0 && <CountBadge>{pendingCount}</CountBadge>}
    >
      {compliance.length === 0 ? (
        <EmptyState>
          <CheckRounded />
          <Typography variant="body2">{t('right-panel.session-compliance.empty')}</Typography>
        </EmptyState>
      ) : (
        <ComplianceList items={compliance} density="panel" />
      )}
    </PanelLayout>
  );
}
